var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBewikiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 54,
    viewBox: "0 0 256 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-bewiki-logo"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 54
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bewiki-logo",
    clipPath: "url(#clip-bewiki-logo)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Imagem-25",
    transform: "translate(-56 205.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82",
    "data-name": "Caminho 82",
    d: "M457.575-202.235c-4.571,2.266-4.844,8.009-.547,10.392a8.186,8.186,0,0,0,6.837.742c3.438-.977,5.352-3.633,4.844-6.72C468.006-202.118,462.107-204.462,457.575-202.235Z",
    transform: "translate(-237.01)",
    fill: "#303036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_83",
    "data-name": "Caminho 83",
    d: "M633.278-202.371c-4.415,2.266-5.313,6.915-1.953,9.884a8.442,8.442,0,0,0,9.65.742c4.3-2.422,4.063-8.087-.469-10.392C638.434-203.152,635.035-203.309,633.278-202.371Z",
    transform: "translate(-343.836 -0.06)",
    fill: "#303036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84",
    "data-name": "Caminho 84",
    d: "M65-192.99v4.61h4.688v28.6l-2.149-.156-2.149-.117v9.181h17.58v-3.164l1.485,1.172c2.227,1.8,4.532,2.5,8.087,2.5,5.2,0,9.025-1.953,12.267-6.29,2.422-3.2,3.36-6.485,3.321-11.6,0-4.883-.859-7.97-3.008-11.1-2.969-4.415-6.29-6.329-11.251-6.6-3.907-.2-6.368.43-8.907,2.3a11.8,11.8,0,0,1-1.8,1.133,70.27,70.27,0,0,1-.2-7.54v-7.5l-8.985-.039H65Zm26.409,17.072a6.89,6.89,0,0,1,2.149,2.657c1.328,2.657,1.328,8.126.039,10.587-1.719,3.2-5.43,4.219-7.931,2.149-1.953-1.641-2.7-3.672-2.7-7.54,0-2.7.156-3.672.9-5.079C85.471-176.347,88.753-177.559,91.409-175.918Z",
    transform: "translate(0 -3.346)",
    fill: "#303036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85",
    "data-name": "Caminho 85",
    d: "M505-192.99v4.61h4.3v28.519H505v8.985h17.971v-16.057l5.157,6.368c2.813,3.516,5.782,7.11,6.524,8.009l1.367,1.68h13.127v-8.985h-4.883l-3.907-4.688a36.942,36.942,0,0,1-3.907-5.2c0-.313,1.8-2.266,4.024-4.376,3.946-3.75,4.024-3.79,5.548-3.555l1.563.234v-7.813h-21.1v7.423h6.055l-4.688,4.688-4.688,4.688-.2-14.533-.2-14.572h-8.868L505-197.6Z",
    transform: "translate(-268.104 -3.346)",
    fill: "#303036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_86",
    "data-name": "Caminho 86",
    d: "M196.013-167.308a19.971,19.971,0,0,0-10.978,8.126c-3.2,5.469-3.125,13.908.2,19.143,3.36,5.274,9.181,8.087,16.916,8.087,5.821,0,10.548-1.641,14.142-4.844,2.227-1.992,3.985-4.844,3.164-5.118-.273-.078-2.657-.7-5.274-1.367l-4.766-1.172-1.719,1.719a5.833,5.833,0,0,1-3.36,1.992c-4.3.7-7.853-1.641-8.282-5.469l-.156-1.172,12.423-.117,12.384-.078v-2.539c0-5.313-1.485-9.181-4.844-12.541a18.881,18.881,0,0,0-8.243-4.688A34.035,34.035,0,0,0,196.013-167.308Zm9.571,8.868a6.115,6.115,0,0,1,2.227,4.219c0,.742-.234.781-6.016.781h-6.016l.391-1.6A6.155,6.155,0,0,1,205.584-158.44Z",
    transform: "translate(-71.709 -21.488)",
    fill: "#303036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_87",
    "data-name": "Caminho 87",
    d: "M335.788-166.291l-8.126.078v8.985h1.758c.977,0,1.758.156,1.758.313s-.781,2.657-1.758,5.548a50.527,50.527,0,0,0-1.758,5.938c0,.391-.156.7-.391.7-.2,0-.391-.352-.391-.781,0-.469-1.328-5.313-3.008-10.783l-2.969-9.962-5.9.117-5.9.117-3.047,8.595c-1.68,4.727-3.36,9.806-3.75,11.329l-.742,2.7-.273-1.719c-.117-.977-.86-3.946-1.6-6.6-.742-2.7-1.328-5.04-1.328-5.2s.781-.313,1.758-.313h1.758v-8.985H280v8.946l2.031.117,2.071.117,4.688,12.58,4.688,12.619h6.094c5.469,0,6.173-.078,6.407-.7.547-1.328,4.962-13.986,5.508-15.705a18.48,18.48,0,0,0,.586-2.735c.039-.547.352.234.7,1.758.391,1.485,1.8,6.016,3.125,10.04l2.461,7.345h12.619l3.282-8.712c1.8-4.766,3.946-10.47,4.805-12.7l1.524-3.985h8.165v16.408H343.68v8.985h22.659v-8.946l-2.031-.117-2.07-.117-.117-12.58-.078-12.58-9.1-.117C347.977-166.37,340.242-166.37,335.788-166.291Z",
    transform: "translate(-131.005 -22.388)",
    fill: "#303036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_88",
    "data-name": "Caminho 88",
    d: "M619-161.507v4.493h4.688v16.408H619v8.985h22.268v-8.985h-3.907V-166H619Z",
    transform: "translate(-337.568 -22.601)",
    fill: "#303036"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBewikiLogo);
export default __webpack_public_path__ + "static/media/bewiki-logo.f02aff319a21a5879d570a991c715815.svg";
export { ForwardRef as ReactComponent };